import { render, staticRenderFns } from "./AdviceTask.vue?vue&type=template&id=931f252e"
import script from "./AdviceTask.vue?vue&type=script&lang=js"
export * from "./AdviceTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports